import React from 'react'
import logo from '/core/img/logo_header.png'

const ShareHeader = ({ shareCode }) => {
  return (
    <header className="bg-white shadow-sm border-b" data-testid="share-header">
      <div className="mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center h-16 relative">
          {/* Left side - Logo */}
          <div className="flex items-center absolute left-0">
            <img 
              src={logo} 
              alt="pix-storage" 
              className="h-6 lg:h-8 mr-2 lg:mr-4"
              data-testid="share-logo"
            />
          </div>

          {/* Right side - Share Code */}
          <div className="mx-auto">
            <div 
              className="bg-gray-700 text-white px-3 py-2 rounded text-sm font-medium"
              data-testid="share-code-display"
            >
              [SHARE CODE] {shareCode}
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}

export default ShareHeader
